<template>
  <div class="image-mapping-config">
    <div class="mapping-rules">
      <!-- 基础资料选项 -->
      <el-checkbox
        v-model="baseChecked"
        :disabled="baseDisabled"
        style="margin-right:0"
      >
      </el-checkbox>
      {{ baseLabel }}

      <!-- 分隔线 -->
      <span class="divider">|</span>

      <!-- 天猫图片选项 -->
      <el-checkbox
        v-model="tmallChecked"
        :disabled="tmallDisabled"
      />
      <span>选择第</span>
      <el-select
          :value="config.optionalRules ? config.optionalRules.index : (config.tmIndex || 1)"
          @input="handleTmIndexChange"
          placeholder="请选择"
          size="small"
          style="width: 50px;"
      >
        <el-option v-for="n in 5" :key="n" :label="`${n}`" :value="n" />
      </el-select>
      <span>张</span>
      <el-select
        :value="config.optionalRules ? config.optionalRules.sourceType : (config.tmImageType || 'tmallItemImage')"
        @input="handleTmImageTypeChange"
        placeholder="请选择"
        size="small"
        style="width: 120px; margin: 0 8px;"
      >
        <el-option label="天猫商品图片" value="tmallItemImage" />
        <el-option label="天猫 3:4 商品图片" value="tmall34Image" />
      </el-select>
      <span>映射</span>
    </div>

    <div class="mapping-tip">
      至少选择一项映射规则，根据配置从左到右生效，若映射图片不符合目标图片尺寸规则，将自动裁剪适配
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageMappingConfig',
  props: {
    value: {
      type: Object,
      default: () => ({
        defaultMapping: 'longImage',
        useTmall: 0,
        tmIndex: 1,
        tmImageType: 'tmallItemImage',
      }),
    },
    baseLabel: {
      type: String,
      default: '基础资料商品长图',
    },
  },
  computed: {
    config: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    baseChecked: {
      get() {
        return !!this.config.defaultMapping;
      },
      set(val) {
        if (val) {
          this.config.defaultMapping = this.baseLabel.includes('白底图') ? 'whiteBgImage' : 'longImage';
        } else {
          this.config.defaultMapping = undefined;
        }
      },
    },
    tmallChecked: {
      get() {
        return !!this.config.optionalRules;
      },
      set(val) {
        if (val) {
          this.$set(this.config, 'optionalRules', {
            index: this.config.tmIndex || 1,
            sourceType: this.config.tmImageType || 'tmallItemImage',
          });
        } else {
          // 取消勾选时，先保存 optionalRules 中的值到 tmIndex/tmImageType，再删除 optionalRules
          // 这样下拉框可以通过回退机制显示保存的值，重新勾选时也能恢复
          const { index, sourceType } = this.config.optionalRules || {};
          this.$set(this.config, 'tmIndex', index || 1);
          this.$set(this.config, 'tmImageType', sourceType || 'tmallItemImage');
          this.$delete(this.config, 'optionalRules');
        }
      },
    },
    // 只有一个选中时，选中的那个不可操作
    baseDisabled() {
      return this.baseChecked && !this.tmallChecked;
    },
    tmallDisabled() {
      return this.tmallChecked && !this.baseChecked;
    },
  },
  methods: {
    handleTmIndexChange(val) {
      if (this.config.optionalRules) {
        this.$set(this.config.optionalRules, 'index', val);
      } else {
        this.$set(this.config, 'tmIndex', val);
      }
    },
    handleTmImageTypeChange(val) {
      if (this.config.optionalRules) {
        this.$set(this.config.optionalRules, 'sourceType', val);
      } else {
        this.$set(this.config, 'tmImageType', val);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.image-mapping-config {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mapping-rules {
  display: flex;
  align-items: center;
  gap: 8px;
}

.divider {
  color: #dcdfe6;
  margin: 0 4px;
}

.mapping-tip {
  font-size: 12px;
  color: red;
  line-height: 1.5;
}
</style>
